function SMSReducer(state={receivedSMSList:[]}, action)
{
    switch(action.type)
    {
    case "SEARCH_RECEIVED_SMS":
        return{
            ...state, 
            receivedSMSList: action.data
        }
        default: 
        return state;
    }
}
export default SMSReducer;